var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFace1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_856)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_201_856)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EDE6E6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 1,
    r: 16,
    fill: "#0E0D0D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 4,
    r: 16,
    fill: "#0E0D0D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 22,
    r: 2,
    fill: "#624230"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 22,
    r: 2,
    fill: "#624230"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_201_856"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace1);
export default __webpack_public_path__ + "static/media/face_1.54d763ee43773c3d84ee6a491810fa09.svg";
export { ForwardRef as ReactComponent };